import Form from "./Form";
import { FormRenderProps as _FormRenderProps } from "./form-t";
import getError from "./get-error";

export default Form;

export type FormRenderProps = _FormRenderProps;

export { getError };
